import React, { Component } from "react";
import Form from "react-jsonschema-form";
import {Button } from "react-bootstrap";
import ReactJson from 'react-json-view'


const log = (type) => console.log.bind(console, type);


//const regex='/(^(((\+44\s?\d{4}|\(?0\d{4}\)?)\s?\d{3}\s?\d{3})|((\+44\s?\d{3}|\(?0\d{3}\)?)\s?\d{3}\s?\d{4})|((\+44\s?\d{2}|\(?0\d{2}\)?)\s?\d{4}\s?\d{4}))(\s?\#(\d{4}|\d{3}))?$)|(^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/'
//This can be a file that the server references :)
//value: {type: "string", title: "Inital Value"},
var varForm={
      schema:{
        title: "Contact List",
        type: "object",
        required: ["id","value","name"],
        properties: {
          type: {type: "string", title: "used for showing correct edit form", default: "CONTACT_LIST"},
          name: {type: "string", title: "Name of the contact list", default: "New Contact list"},
          id: {type: "string", title: "ID of the variable (must be unique)", default: "CONTACT_LIST_X"},
          user: { "type": "boolean", "title": "user",  default:true },
          broadcast: { "type": "boolean", "title": "Broadcast", "description": "Broadcast when this variable changes value", default:false},
          log: { "type": "boolean", "title": "log", "description": "Log when this variable changes", default:false},
          override: { "type": "boolean", "title": "user", "description": "sets the inital value when system restarts", default:false },
          value: {
            "title": "Contact List",
            "type": "array",
            "description":"Email or Mobile number",
            "items": {
              "type": "string",
              "placeholder": "mobile or email"
            }
          }
        }





      },
      uiSchema:{
        id:   {"ui:readonly":true},
        user: {"ui:widget": "hidden"},
        type: {"ui:widget": "hidden"},
        log: {"ui:widget": "hidden"},
        broadcast: {"ui:widget": "hidden"},
        override: {"ui:widget": "hidden"},
        value: {
          "ui:options": {orderable: false  }
        }
      },




}

var contactTree={
  schema:{
        "type": "object",
        "properties": {
          "value": {
            "title": "Unorderable items",
            "type": "array",
            "items": {
              "type": "string",
              "default": "lorem ipsum"
            }
          }
        }
},
    uiSchema:{
      value: {
        "ui:options": {orderable: false  }
      }
  }
}





export default class VarModify extends Component {
    constructor(props) {
      super(props);
      this.state = {
        data:props.data,
        advancedEdit:false
      };
    }
    componentWillMount() {

      console.log(this.props.data)
      this.setState({data:this.props.data})
      varForm.uiSchema.id["ui:readonly"]=!this.props.editMode
      this.setState({editMode:false})
    //  actionForms.macro.schema.properties.data.enum=["TEST1","TEST2","TEST3"]
    }
    onChangeValue=(d)=>{
      let temp=this.state.data
      console.log(temp)
      console.log(d)
      temp.value=d.formData.value
      console.log(temp)
      this.setState({data:temp})
    }
    onChange=(d)=>{
      this.setState({data:d.formData})
    }
    jsonEdit=(d)=>{
      console.log("Edit")
      console.log(d)
      if(typeof(d.existing_value)!=typeof(d.new_value)){
        alert("The Type has changed this key was a "+typeof(d.existing_value))
      }
      this.setState({data:d.updated_src})
      console.log(this.state.data)
    }

    delete=()=>{

      let temp=this.state.data
      let data={
        cmd:"vars",
        type:"delete",
        id:temp.id
      }
      this.props.callback(data)


    }

    submit=(d)=>{
      console.log(d)
      if (d.formData.id.length>0){
      let data={
        cmd:"vars",
        type:"modify",
        id:d.formData.id,
        data:d.formData
      }
      console.log(data)
      this.props.callback(data)
      }
    }

    submitAdvanced=()=>{
      let temp=this.state.data
      let data={
        cmd:"vars",
        type:"modify",
        id:temp.id,
        data:temp
      }
      this.props.callback(data)


    }

    jsonAdd=(d)=>{
      console.log("Add")
      console.log(d)
    }

    jsonDelete=(d)=>{
      console.log("delete")
      console.log(d)
      if(d.name=="cmd"){
        alert("cmd is always required")
        return false
      }
    }

    goAdvanced=()=>{
      console.log("Change edit")
      this.setState({advancedEdit:!this.state.advancedEdit})
    }

    cancel=()=>{
      console.log("Cancel")
      this.props.callback({"cmd":"cancel"})

    }

    render(){
      const validForm=true
      let vartype=this.props.type
    //  console.log("Form Edit")
      //console.log(validForm)
      if(validForm==true && this.state.advancedEdit==false){
        return (<span>

          <Form schema={varForm.schema}
          uiSchema={varForm.uiSchema}
                formData={this.state.data}
                 onChange={this.onChange}
                 onSubmit={this.submit}
                 onError={log("errors")} >
                 <Button type="submit">Save</Button>
                 <Button type="button" onClick={this.cancel}>Cancel</Button>
                 {!this.props.editMode?(<Button type="button" onClick={this.delete}>Delete List</Button>):("")}
                    <Button className="pull-right" onClick={this.goAdvanced}>Advanced</Button>
                 </Form>
          </span>
        )
      }
      else{
        return (
              <div>
                  <h4>Advanced edit for `{this.state.data.cmd}`, displaying JSON</h4>
                  <div className="jsonPAD">
                  <ReactJson  theme="solarized"  name={false} src={this.state.data}  enableClipboard={false} displayObjectSize={false} displayDataTypes={false} onEdit={this.jsonEdit} onDelete={this.jsonDelete} onAdd={this.jsonAdd}/>
                  </div>
                  <Button onClick={this.submitAdvanced}>Save</Button>
                  <Button type="button" onClick={this.cancel}>Cancel</Button>
                   {validForm ? (<Button className="pull-right" onClick={this.goAdvanced}>Form view</Button>):(<span></span>)}
              </div>

        )

}





    }

}



// WEBPACK FOOTER //
// ./src/programmerComponents/VarModify.js